<div class="flex overflow-y-auto overflow-x-hidden fixed right-0 left-0 top-4 z-40 justify-center items-center md:inset-0 h-modal sm:h-full"
    [id]="modalId" aria-hidden="true">
    <div class="absolute inset-0 bg-black bg-opacity-25 backdrop-blur-sm"></div>

    <!-- <div class="relative px-4 w-screen max-w-2xl h-screen md:h-auto"> -->
        <div class="relative px-4 w-screen h-screen md:h-auto" [ngClass]="{  
    'max-w-2xl': size === 'sm',  
    'max-w-5xl': size === 'md',  
    'max-w-7xl': size === 'lg',
    'max-w-9xl': size === 'xlg'
  }">
            <div *ngIf="showToast" class="w-full flex justify-end">
                <app-notification [isError]="isToastError" [message]="toastMessage"></app-notification>
            </div>

            <div class="relative bg-white rounded-2xl shadow-lg">

                <div class="flex justify-between items-start p-5 rounded-t border-b">
                    <h3 class="text-xl font-semibold">
                        {{ titleModal }}
                    </h3>
                    <ng-content select="[modal-button-close]"></ng-content>
                </div>

                <div class="px-6  space-y-2">
                    <ng-content></ng-content>
                </div>

                <div class="items-center p-6 rounded-b border-t border-gray-200">
                    <ng-content select="[modal-footer]"></ng-content>
                </div>
            </div>
        </div>
    </div>